import { Button, DropdownMenu, DropdownMenuItem, Icon } from '@aon/aon-tws-common-ui';
import React, { useState } from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { CopyTemplateModal } from './CopyTemplateModal';

const DropdownContainer = styled.div`
	position: absolute;
`;

const downArrow: React.CSSProperties = {
	fontSize: '8px',
	left: '10px',
	position: 'relative',
};

export interface IBuildSurveyButtonProps {
	shouldShowDropdown: boolean;
	dropdownPositionX: number;
	dropdownPositionY: number;
	buildNewSurvey: () => void;
}

export const BuildSurveyButton = (props: IBuildSurveyButtonProps) => {
	const [isDropdownOpen, setDropdown] = useState<boolean>(false);
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const { dropdownPositionX, dropdownPositionY, shouldShowDropdown, buildNewSurvey } = props;

	function BuildButton() {
		return (
			<Button id='BuildSurvey' onClick={buildNewSurvey} color='primary' size='large'>
				<Icon name='design' /> {ContentConstants.BUTTONS_BUILD_NEW_SURVEY}
			</Button>
		);
	}

	function Dropdown() {
		return (
			<>
				<Button id='BuildSurvey' onClick={() => setDropdown(!isDropdownOpen)} color='primary' size='large'>
					{ContentConstants.BUTTONS_BUILD_NEW_SURVEY}
					<Icon name='caret-down' style={downArrow} />
				</Button>
				<DropdownContainer>
					<DropdownMenu open={isDropdownOpen} x={dropdownPositionX} y={dropdownPositionY} onBlur={() => setDropdown(false)}>
						<DropdownMenuItem onClick={buildNewSurvey}>{ContentConstants.ACTIONMENU_CREATE_NEW}</DropdownMenuItem>
						<DropdownMenuItem onClick={() => setIsModalOpen(true)}>{ContentConstants.ACTIONMENU_PICK_FROM_TEMPLATE}</DropdownMenuItem>
					</DropdownMenu>
				</DropdownContainer>
			</>
		);
	}

	return (
		<>
			{shouldShowDropdown ? Dropdown() : BuildButton()}
			<CopyTemplateModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
		</>
	);
};
